import { render } from "./MeasureDetails.vue?vue&type=template&id=e08cd194"
import script from "./MeasureDetails.vue?vue&type=script&lang=js"
export * from "./MeasureDetails.vue?vue&type=script&lang=js"

import "./MeasureDetails.vue?vue&type=style&index=0&id=e08cd194&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__